import { useQueryClient } from '@tanstack/react-query';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { ModelSizeDetails, UpdateModelSizeBody } from '../types';

export function useModelSizeDetails(modelSizeId: string) {
  const queryClient = useQueryClient();

  const { isFetching, data } = useApiQuery<ModelSizeDetails>(
    `/models/sizes/${modelSizeId}`,
    {
      queryKey: ['modelSizeDetails', modelSizeId],
      initialData: null,
    }
  );

  const updateModelSizeMutation = useApiMutation<
    UpdateModelSizeBody,
    ModelSizeDetails
  >(
    `/models/sizes/${modelSizeId}`,
    {
      method: 'PATCH',
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(['modelSizeDetails', modelSizeId], data);
      },
    }
  );

  return {
    isFetching,
    details: data,
    updateModelSizeMutation,
  } as const;
}
